import BreadCrumb from "components/Common/BreadCrumb";
import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";

import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import CollapseFilter from "components/Common/CollapseFilter";
import DatePickerCustom from "components/Common/DatePickerCustom";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import LabelWrapper from "components/Common/LabelWrapper";
import ModalConfirm from "components/Common/ModalConfirm";
import ModalPreview from "components/Common/ModalPreview";
import {
  COLOR_ADULT_VERIFY,
  COLOR_CONTENT_AI_APPROVAL_STATUS,
  COLOR_CONTENT_COMMENT_STATUS,
  COLOR_EXPERIENCE_USER,
  COLOR_STATUS_ACTIVE_DISABLE,
  COLOR_TALENT_USER_TYPE,
  LIST_CONTENT_AI_APPROVAL_STATUS_OPTION,
  LIST_CONTENT_COMMENT_STATUS_OPTION,
  LIST_OPTION_ADULT_VERIFY,
  LIST_OPTION_DURATION_WORK,
  LIST_OPTION_EXPERIENCE,
  LIST_OPTION_GENDER,
  LIST_OPTION_GENDER_NORMAL,
  LIST_OPTION_SALARY_TYPE,
  LIST_TALENT_USER_TYPE_OPTION,
  STATUS_ACTIVE_DISABLE_OPTION,
} from "helpers/constans";
import { formatDateStringToKorea, formatDateStringToUTC, getPlatFormImage } from "helpers/format";
import CountUp from "react-countup";
import DropdownOptionNew from "components/Common/DropdownOptionNew";
import noImageJob from "../../assets/images/no-job-post.png";
import CopyWrapper from "components/Common/CopyWrapper";
import jobPostApi from "api/jobPostApi";
import { capitalizeFirstLetter } from "utils";
import ModalMultiPreview from "components/Common/ModalMultiPreview";
import { getTalents } from "store/talent/thunk";
import DatePicker from "react-datepicker";
import TalentForm from "./TalentForm";
import talentApi from "api/talentApi";
import { getPhoneFormat } from "components/Common/PhoneInput";
import { PatternFormat } from "react-number-format";
import CollapseContent from "components/Common/CollapseContent";
import regionApi from "api/regionApi";
import VerifiedAdultInfo from "components/Common/VerifiedAdultInfo";
import TooltipCustom from "components/Common/TooltipCustom";
import { Link } from "react-router-dom";

registerLocale("en", en);
registerLocale("ko", ko);

const SORT_BY_DEFAULT = 'createdAt';
const ORDER_BY_DEFAULT = 'desc';

const TalentManagement = () => {
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    fullname: withDefault(StringParam, ""),
    nickname: withDefault(StringParam, ""),
    phoneNumber: withDefault(StringParam, ""),
    dateOfBirth: withDefault(StringParam, ""),
    gender: withDefault(StringParam, ""),
    type: withDefault(StringParam, ""),
    approvedStatus: withDefault(StringParam, ""),
    isAgeVerified: withDefault(StringParam, null),
    isNewbie: withDefault(StringParam, ""),
    isVisibleInRecruitment: withDefault(StringParam, ""),
    startDate: withDefault(StringParam, ""),
    endDate: withDefault(StringParam, ""),
    // sortBy: withDefault(StringParam, SORT_BY_DEFAULT),
    // orderBy: withDefault(StringParam, ORDER_BY_DEFAULT),
  });

  const [fullNameSearch, setFullNameSearch] = useState<string>(query?.fullname || "");
  const [nickNameSearch, setNickNameSearch] = useState<string>(query?.nickname || "");
  const [phoneNumberSearch, setPhoneNumberSearch] = useState<string>(query?.phoneNumber || "");
  const [birthDaySearch, setBirthDaySearch] = useState<any>(query?.dateOfBirth
      ? moment(query?.dateOfBirth || "", "Y-MM-DD").toDate()
      : null);
  const [genderSearch, setGenderSearch] = useState<any>(
    LIST_OPTION_GENDER?.find(
      (item) => item?.value === (query?.gender)
    )?.value ?? ""
  );
  const [talentUserTypeSearch, setTalentUserTypeSearch] = useState<any>(
    LIST_TALENT_USER_TYPE_OPTION?.find(
      (item) => item?.value === (query?.type)
    )?.value ?? ""
  );
  const [approvedStatusSearch, setApprovedStatusSearch] = useState<any>(
    LIST_CONTENT_AI_APPROVAL_STATUS_OPTION?.find(
      (item) => item?.value === (query?.approvedStatus)
    )?.value ?? ""
  );
  const [verifyAdultSearch, setVerifyAdultSearch] = useState<any>(
    LIST_OPTION_ADULT_VERIFY?.find(
      (item) => item?.value === (query?.isAgeVerified === "true" ? 1 : (query?.isAgeVerified === "false" ? 0 : ""))
    )?.value ?? ""
  );
  const [experienceSearch, setExperienceSearch] = useState<any>(
    LIST_OPTION_DURATION_WORK?.find(
      (item) => item?.value === (query?.isNewbie)
    )?.value ?? ""
  );
  const [statusSearch, setStatusSearch] = useState<any>(
    STATUS_ACTIVE_DISABLE_OPTION?.find(
      (item) => item?.value === parseInt(query?.isVisibleInRecruitment)
    )?.value ?? ""
  );
  const [dateSearch, setDateSearch] = useState<any[]>([
    query?.startDate
      ? moment(query?.startDate || "", "Y-MM-DD").toDate()
      : null,
    query?.endDate ? moment(query?.endDate || "", "Y-MM-DD").toDate() : null,
  ]);
  const [startDate, endDate] = dateSearch;

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [itemToEdit, setItemToEdit] = useState<any>(null);
  const [itemToDelete, setItemToDelete] = useState<any>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const [linkImage, setLinkImage] = useState<any>(null);
  const [dataRegions, setDataRegions] = useState<any>([]);
  const [summary, setSummary] = useState<any>(null);

  const selectLayoutState = (state: any) => state.TalentList;
  const CompanyProperties = createSelector(selectLayoutState, (state) => ({
    talents: state?.talents,
    isTalentLoading: state.isTalentLoading,
    isTalentSuccess: state.isTalentSuccess,

    error: state.error,
  }));

  // Inside your component
  const { talents, isTalentLoading } = useSelector(CompanyProperties);

  const initSummary = async () => {
    try {
      const res = await talentApi.getSummaryTalent(query);
      setSummary(res?.data);
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    dispatch(getTalents(query));
    initSummary();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, JSON.stringify(query)]);

  const searchData = () => {
    setQuery({
      ...query,
      fullname: encodeURIComponent(fullNameSearch.trim()) || "",
      nickname: encodeURIComponent(nickNameSearch.trim()) || "",
      phoneNumber: (phoneNumberSearch.trim()) || "",
      dateOfBirth: birthDaySearch ? moment(birthDaySearch).format("Y-MM-DD") : "",
      gender: genderSearch,
      type: talentUserTypeSearch,
      salaryTypes: talentUserTypeSearch,
      isAgeVerified: (verifyAdultSearch === 1) ? true : (verifyAdultSearch === 0 ? false : ""),
      isNewbie: (experienceSearch === 0) ? true : (experienceSearch === 1 ? false : ""),
      isVisibleInRecruitment: (statusSearch === 1) ? true : (statusSearch === 0 ? false : ""),
      approvedStatus: approvedStatusSearch,
      startDate: startDate
        ? formatDateStringToUTC(
            moment(new Date(startDate)).startOf("day").format("Y-MM-DD HH:mm:ss")
          )
        : "",
      endDate: endDate
        ? formatDateStringToUTC(
            moment(new Date(endDate)).endOf("day").format("Y-MM-DD HH:mm:ss")
          )
        : "",
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        fullname: "",
        nickname: "",
        phoneNumber: "",
        dateOfBirth: "",
        gender: "",
        type: "",
        approvedStatus: "",
        isAgeVerified: "",
        isNewbie: "",
        isVisibleInRecruitment: "",
        startDate: "",
        endDate: "",
        sortBy: SORT_BY_DEFAULT,
        orderBy: ORDER_BY_DEFAULT,
        time_request: +new Date(),
        page: 1,
      },
      "push"
    );
    setFullNameSearch("");
    setNickNameSearch("");
    setPhoneNumberSearch("");
    setBirthDaySearch(null);
    setGenderSearch("");
    setTalentUserTypeSearch("");
    setApprovedStatusSearch("")
    setVerifyAdultSearch("");
    setExperienceSearch("");
    setStatusSearch("");
    setDateSearch([null, null]);
  };

  // Begin::Update User
  const onCloseClick = () => {
    setItemToEdit((_prev: any) => null);
    setIsOpen((_prev) => false);
  };

  const handleOnConfirmUpdate = async (item: {
    id: number;
    status: boolean;
  }) => {
    try {
      if (!item) return;

      const response: any = await talentApi.updateVisibleRecruitmentTalent({
        ids: [item?.id],
        isVisibleInRecruitment: item?.status,
      });

      if (response?.code === 200) {
        dispatch(getTalents(query));
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        toast(`${response?.message}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      toast(`${error || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };


  const triggerRefresh = () => {
    onCloseClick();
    dispatch(getTalents(query));
  };
  //End::Update User

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 60,
        thClass: "whitespace-nowrap",
        Cell: ({ ...props }) => {
          return (
            <div style={{ width: 35 }}>
              {talents?.pagination?.total -
                ((query?.page - 1) * query?.limit + props?.row?.index)}
            </div>
          );
        },
      },
      {
        Header: t("Resume Visibility"),
        accessor: "isVisibleInRecruitment",
        thWidth: 140,
        thClass: "text-center  whitespace-nowrap",
        Cell: (cell: any) => {
          const status = cell?.value;
          const item = cell?.row?.original;

          // if (status === "DELETED") {
          //   return (
          //     <span
          //       className={`rounded-pill badge bg-${COLOR_CONTENT_COMMENT_STATUS[status] || "secondary"
          //         }`}
          //     >
          //       {t(
          //         LIST_CONTENT_COMMENT_STATUS_OPTION?.find(
          //           (item: any) => item?.value === status
          //         )?.label || ""
          //       )}
          //     </span>
          //   )
          // }

          return (
            <div className="form-check form-switch form-switch-sm text-center" dir="ltr">
              <input
                type="checkbox"
                className="form-check-input"
                name="status"
                checked={status}
                onChange={(e) => {
                  const value = e.target.checked;
                  handleOnConfirmUpdate({
                    id: item.id,
                    status: value,
                  });
                }}
              />
            </div>
          )
        },
      },
      {
        Header: t("Talent User Type"),
        accessor: "type",
        thWidth: 150,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const status: any = cell?.value;
          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${
                  COLOR_TALENT_USER_TYPE[status] || "secondary"
                }`}
              >
                {t(
                  LIST_TALENT_USER_TYPE_OPTION?.find(
                    (item: any) => String(item?.value) === String(status)
                  )?.label || ""
                )}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Approved Status"),
        accessor: "profile.status",
        thWidth: 150,
        thClass: "text-center",
        Cell: ({ value, row }: any) => {
          return (
            <div className="position-relative d-flex align-items-center gap-1 justify-content-center">
              {
                 value ? (
                  <span className={`rounded-pill badge bg-${COLOR_CONTENT_AI_APPROVAL_STATUS[value] || "secondary"}`}>
                    {t(LIST_CONTENT_AI_APPROVAL_STATUS_OPTION?.find((item) => item?.value === value)?.label || "")}
                  </span>
                 ): "-"
              }
            </div>
          );
        },
      },
      {
        Header: t("Adult Verify"),
        accessor: "isAgeVerified",
        filterable: false,
        sortable: false,
        thWidth: 160,
        thClass: "",
        Cell: (cell: any) => {
          const status = cell?.value ? 1 : 0;

          return (
            <span
              className={`rounded-pill badge bg-${COLOR_ADULT_VERIFY[status] || "secondary"
                }`}
            >
              {t(
                LIST_OPTION_ADULT_VERIFY?.find(
                  (item: any) => String(item?.value) === String(status)
                )?.label || ""
              )}
            </span>
          );
        },
      },
      {
        Header: t("Verified Adult Info"),
        accessor: "verifiedInfoLogs",
        filterable: false,
        sortable: false,
        thWidth: 230,
        Cell: (cell: any) => {
          let isAgeVerified = cell?.row?.original?.isAgeVerified;
          let verifiedInfoLog = cell?.value;

          return (
            (isAgeVerified) ? (
              <VerifiedAdultInfo verifiedInfoLog={verifiedInfoLog?.[0]} />
            ) : (
              <>-</>
            )
          );
        },
      },
      {
        Header: t("Photo"),
        accessor: "profile.imageUrls",
        thClass: "text-center whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 120,
        Cell: (cell: any) => {
          const itemImages = cell?.value;
          const jobImage = itemImages?.[0] || "";
          const formatPreviewImages = itemImages?.length > 0 && itemImages?.map((image: any) => ({url: image}));

          return <div className="w-100 text-center " style={{ minWidth: "80px" }}>
              {
                itemImages ? (
                  <div
                    style={{ width: "80px" }}
                    className="m-auto cursor-pointer"
                    onClick={() => setLinkImage(itemImages?.length > 1 ? { urls: formatPreviewImages } : { url: jobImage })}
                  >
                    <img
                      src={jobImage ?? noImageJob}
                      width={70}
                      height={70}
                      className=""
                      style={{objectFit: "contain"}}
                      alt="thumbnail"
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src = noImageJob;
                      }}
                    />
                  </div>
                ) : "-"
              }
              </div>
        },
      },
      {
        Header: t("Full Name"),
        accessor: "profile.fullname",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 200,
        Cell: (cell: any) => {
          const contactName = cell?.value;
          const item = cell?.row?.original;

          return contactName ? <div 
              className="cursor-pointer text-primary"
              onClick={() => {
                setIsOpen(true);
                setItemToEdit(item);
              }}
              >
            <CopyWrapper contentCopy={contactName}>
              {`${contactName}`}
            </CopyWrapper>
          </div> : '-';
        },
      },
      {
        Header: t("Nick Name"),
        accessor: "profile.nickname",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 200,
        Cell: (cell: any) => {
          const contactName = cell?.value;

          return contactName ? <div className="cursor-pointer">
            <CopyWrapper contentCopy={contactName}>
              {`${contactName}`}
            </CopyWrapper>
          </div> : '-';
        },
      },
      {
        Header: t("Birthday"),
        accessor: "profile.dateOfBirth",
        filterable: false,
        sortable: false,
        thWidth: 160,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const date = cell?.value ? moment(cell?.value).format("YYYY-MM-DD") : "";

          return (
            <CopyWrapper contentCopy={date}>
              <span>{date || "-"}</span>
            </CopyWrapper>
          );
        },
      },
      {
        Header: t("Gender"),
        accessor: "profile.gender",
        filterable: false,
        sortable: false,
        thWidth: 100,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const gender = cell?.value;
          return gender ? (
            <div style={{ minWidth: 80 }}>
              {t(
                  LIST_OPTION_GENDER?.find(
                    (item: any) => String(item?.value) === String(gender)
                  )?.label || ""
              )}
            </div>
          ): "-";
        },
      },
      {
        Header: t("Phone Number"),
        accessor: "profile.phoneNumber",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 150,
        Cell: (cell: any) => {
          let { format } = getPhoneFormat(cell?.value);
          const showFormat = format !== "####-####" ? format : "#####################";

          return (
            cell?.value ? (
              <div className="cursor-pointer" style={{ width: "135px" }}>
                <CopyWrapper contentCopy={cell?.value}>
                  <PatternFormat
                    value={cell?.value}
                    displayType="text"
                    format={showFormat}
                  />
                </CopyWrapper>
              </div>
            ) : "-"
          );
        },
      },
      {
        Header: t("Introduce"),
        accessor: "workingCondition.bio",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap",
        thWidth: 260,
        Cell: (cell: any) => {
          return cell?.value ? (
            <CopyWrapper
              contentCopy={cell?.value}
              style={{ minWidth: "230px", whiteSpace: "pre-line" }}
            >
              <CollapseContent
                style={{ maxWidth: "230px" }}
                dataOriginal={cell?.value}
                isRank={false}
                isInlineBlock={true}
                isShowModal={true}
                titleModal={t("Introduce")}
                numberCharactor={50}
              />
            </CopyWrapper>
          ) : "-";
        },
      },
      {
        Header: t("Experience"),
        accessor: "workingCondition.isNewbie",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap text-center",
        thWidth: 220,
        Cell: (cell: any) => {
          const experience = cell?.value === true ? 0 : cell?.value === false ? 1 : null;
          return experience !== null ? (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${COLOR_EXPERIENCE_USER[experience] || "secondary"
                  }`}
              >
                {t(
                  LIST_OPTION_EXPERIENCE?.find(
                    (item: any) => item?.value === experience
                  )?.label || ""
                )}
              </span>
            </div>
          ) : (
            <div className="text-center">-</div>
          );
        },
      },
      {
        Header: t("Working Region"),
        accessor: "workingCondition.regions",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 280,
        Cell: (cell: any) => {
          const regions: any = cell?.value;

          return (regions?.length > 0) ? (
            <div className="d-flex flex-wrap align-items-center gap-1">
              {regions.map((item: any, index: number) => {
                const region1 = item?.region?.name?.trim() || "";
                const region2 = item?.subRegion?.name?.trim() || "";
                const displayText = region2 ? `${region1} - ${region2}` : region1;

                return (
                  <div
                    key={index}
                    className="d-flex align-items-center gap-1 bg-primary text-white badge rounded-pill"
                  >
                    {displayText}
                  </div>
                );
              })}
            </div>
          ) : "-";
        },
      },
      {
        Header: t("User Info"),
        accessor: "Store",
        filterable: false,
        sortable: false,
        thWidth: 280,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          let userProvider = item?.provider;
          let lowText = userProvider ? userProvider.toLowerCase() : "";
          let imgPlatform = getPlatFormImage(userProvider);

          return (userProvider || item?.email) ? (
            <div
              className="d-flex gap-2 flex-column"
            >
              <div className="cursor-pointer d-flex gap-2 align-items-center whitespace-nowrap">
                <div style={{ width: "25px" }}>
                  {imgPlatform && (
                    <img
                      src={imgPlatform}
                      width={25}
                      height={25}
                      alt={userProvider}
                    />
                  )}
                </div>
                <div className="cursor-pointer">
                  {t(
                    capitalizeFirstLetter(
                      lowText === "default" || lowText == "guest"
                        ? "Email"
                        : lowText
                    )
                  )}
                </div>
              </div>

              <div className="d-flex align-items-center gap-2">
                <small>{t("Email SNS")}: <b>{item?.email}</b></small> 
              </div>
            </div>
          ): "-";
        },
      },
      {
        Header: t("Registered at"),
        accessor: "registeredAt",
        filterable: true,
        sortable: false,
        thWidth: 140,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return cell?.value ? (
            <div className="text-end">
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
              </span>
            </div>
          ): <div className="text-end">-</div>
        },
      },
      {
        Header: t("Visible recruitment at"),
        accessor: "visibleInRecruitmentAt",
        filterable: true,
        sortable: false,
        thWidth: 180,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

         return cell?.value ? (
            <div className="text-end">
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
              </span>
            </div>
          ): <div className="text-end">-</div>
        },
      },
      {
        Header: t("Action"),
        thClass: "text-center whitespace-nowrap",
        thWidth: 100,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul
              className="list-inline flex-wrap justify-content-center hstack gap-2 mb-0"
              style={{ minWidth: "70px" }}
            >
              <TooltipCustom title={t("Button Update Talent")} id={`detail-${item?.id}`}>
                <Link
                  className="btn btn-sm btn-soft-primary edit-item-btn"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsOpen(true);
                    setItemToEdit(item);
                  }}
                >
                  <i className="ri-pencil-fill align-bottom"></i>
                </Link>
              </TooltipCustom>
            </ul>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n?.language, talents?.pagination?.total, query?.page]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };
  // Begin::Delete

  const onCloseImageClick = () => {
    setLinkImage(null);
  };

  const handleActionDelete = async (id: any) => {
    if (!id) return;

    try {
      setIsConfirmLoading((_prev) => true);
      const response: any = await jobPostApi.deleteJobPost(id);
      // console.log(response);
      if (response?.code) {
        setIsConfirmLoading((_prev) => false);
        dispatch(getTalents(query));
        setItemToDelete(false);
        toast(
          `${t("The job posting has been deleted.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };
  // End::Delete

  useEffect(() => {
    const handleCallAllOption = async () => {
      try {
        const resRegion: any = await regionApi.getRegions();
        if (resRegion?.data) {
          // const formatRegions = resRegion?.data?.map((item: any) => {
          //   const formatSubRegion = item?.subRegions?.map((sub: any) => {
          //     return {
          //       value: sub?.id,
          //       label: sub?.name
          //     }
          //   })
          //   return {
          //     value: item?.id,
          //     label: item?.name,
          //     children: formatSubRegion || []
          //   }
          // })
          setDataRegions(resRegion?.data)
        }
      } catch (error: any) {
        return error;
      }
    };

    handleCallAllOption();
  }, [])

  useEffect(() => {
    document.title = `${t("Talent")} | OnnyJob`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);
  

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Talent")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <div className="d-block d-xl-flex justify-content-between align-items-start">
                    <div
                      className="d-flex w-100 flex-wrap gap-3 gap-md-2 menu-card-talent justify-content-start mb-3 mb-xl-2 position-relative"
                      style={{ maxWidth: "100%" }}
                    >
                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total Talent")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={talents?.pagination?.total || 0}
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total Member Talent")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={
                                      summary?.member || 0
                                    }
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total Non-Member Talent")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={
                                      summary?.["non-member"] || 0
                                    }
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="card-animate mb-0 me-0 me-md-2 mb-1 bg-primary-subtle text-primary border-0">
                        <CardBody className="p-3">
                          <div className="d-flex align-items-center ">
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-uppercase fw-medium text-primary text-truncate fs-12 mb-0">
                                {t("Total System Talent")}
                              </p>
                            </div>
                          </div>
                          <div className="d-flex align-items-end justify-content-between mt-2 pt-0">
                            <div>
                              <h4 className="fs-20 fw-semibold ff-secondary mb-0">
                                <span className="counter-value text-primary">
                                  <CountUp
                                    start={0}
                                    end={
                                      summary?.system || 0
                                    }
                                    duration={1}
                                  />
                                </span>
                              </h4>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </div>
                    <div className="col-sm-auto text-end">
                      <button
                        type="button"
                        className="btn btn-success d-md-block"
                        onClick={() => {
                          setIsOpen(true);
                          setItemToEdit(null);
                        }}
                      >
                        <i className="ri-add-fill align-bottom me-1"></i>{" "}
                        {t("Button Create Talent")}
                      </button>
                    </div>
                  </div>
                </CardHeader>
                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0 mt-md-2">
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={`${t("Full Name")}`}
                          isShow={!!fullNameSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Full Name")}...`}
                            value={fullNameSearch}
                            onChange={(e) => setFullNameSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={`${t("Nick Name")}`}
                          isShow={!!nickNameSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Nick Name")}...`}
                            value={nickNameSearch}
                            onChange={(e) => setNickNameSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={`${t("Phone Number")}`}
                          isShow={!!phoneNumberSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Phone Number")}...`}
                            value={phoneNumberSearch}
                            onChange={(e) => setPhoneNumberSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2 adult-verify date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          isShow={!!birthDaySearch}
                          label={`${t("Birthday")}`}
                        >
                          <DatePicker
                            name={"dateOfBirth"}
                            className="form-control w-full"
                            selected={birthDaySearch ?? null}
                            placeholderText={`${t("Input/ Choose Birthday")}...`}
                            onChange={(date: any) => {
                              setBirthDaySearch(date)
                            }}
                            dateFormat="yyyy-MM-dd"
                            isClearable={!!birthDaySearch}
                          />

                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Gender")} isShow={true}>
                          <DropdownOptionNew
                            name="required-gender"
                            dataList={LIST_OPTION_GENDER_NORMAL || []}
                            placeholder={`${t("Gender")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={genderSearch}
                            onChangeSelect={(e: any) =>
                              setGenderSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Talent User Type")} isShow={true}>
                          <DropdownStatusNew
                            name="talent-user-type"
                            dataList={LIST_TALENT_USER_TYPE_OPTION || []}
                            placeholder={`${t("Talent User Type")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={talentUserTypeSearch}
                            onChangeSelect={(e: any) =>
                              setTalentUserTypeSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_TALENT_USER_TYPE}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Approved Status")} isShow={true}>
                          <DropdownStatusNew
                            name="talent-user-type"
                            dataList={LIST_CONTENT_AI_APPROVAL_STATUS_OPTION || []}
                            placeholder={`${t("Approved Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={approvedStatusSearch}
                            onChangeSelect={(e: any) =>
                              setApprovedStatusSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_CONTENT_AI_APPROVAL_STATUS}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Adult Verify")} isShow={true}>
                          <DropdownStatusNew
                            name="verify-adult"
                            dataList={LIST_OPTION_ADULT_VERIFY || []}
                            placeholder={`${t("Adult Verify")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={verifyAdultSearch}
                            onChangeSelect={(e: any) =>
                              setVerifyAdultSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_ADULT_VERIFY}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Experience")} isShow={true}>
                          <DropdownStatusNew
                            name="isNewbie"
                            dataList={LIST_OPTION_EXPERIENCE || []}
                            placeholder={`${t("Experience")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={experienceSearch}
                            onChangeSelect={(e: any) =>
                              setExperienceSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_EXPERIENCE_USER}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Resume Visibility")} isShow={true}>
                          <DropdownStatusNew
                            name="status"
                            dataList={STATUS_ACTIVE_DISABLE_OPTION || []}
                            placeholder={`${t("Resume Visibility")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={statusSearch}
                            onChangeSelect={(e: any) =>
                              setStatusSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_STATUS_ACTIVE_DISABLE}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-3 mt-md-3 mt-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date")}
                          isShow={!!startDate || !!endDate}
                        >
                          <DatePickerCustom
                            startDate={startDate || null}
                            endDate={endDate || null}
                            onChangePicker={handleChangePicker}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        lg={3}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed sticky-table-talent-media"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={talents?.items?.length ? talents?.items : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={talents?.pagination?.total}
                      customPageCount={Math.ceil(
                        Number(talents?.pagination?.total) /
                          Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sortBy: query.sortBy,
                        orderBy: query.orderBy,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isTalentLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <Modal isOpen={isOpen} centered={true} size="xl" scrollable={true}>
          <ModalHeader toggle={onCloseClick}>
            <>
              {!!itemToEdit?.id
                ? t("Button Update Talent")
                : t("Button Create Talent")}
            </>{" "}
            <>
              {itemToEdit?.id && (" - " + (itemToEdit?.profile?.fullname || "") || "")}
            </>
          </ModalHeader>
          <ModalBody>
            <div style={{ minHeight: "calc(100dvh - 200px)" }} className="mt-1">
              <TalentForm
                id={String(itemToEdit?.id || "")}
                dataRegions={dataRegions}
                triggerRefresh={triggerRefresh}
                onClose={onCloseClick}
                setLinkImage={setLinkImage}
              />
            </div>
          </ModalBody>
        </Modal>

        {itemToDelete && (
          <ModalConfirm
            header={t("Delete Job Post")}
            isOpen={itemToDelete}
            isLoading={isConfirmLoading}
            onClose={() => setItemToDelete(false)}
            onConfirm={() => handleActionDelete(itemToDelete?.id)}
          />
        )}

        <ModalPreview
          type={"IMAGE"}
          isOpen={!!linkImage?.url}
          url={linkImage?.url}
          onClose={() => onCloseImageClick()}
        />

        <ModalMultiPreview
          isOpen={!!linkImage?.urls}
          urls={linkImage?.urls || []}
          onClose={() => onCloseImageClick()}
        />
      </div>
    </React.Fragment>
  );
};

export default TalentManagement;
